import React from "react";
import { useTranslation } from "react-i18next";
const Privacy = () => {
  const { t } = useTranslation();
  return (
    <div id="body">
      <section>
        <h2>{t("privacy.title1")}</h2>
        <p>{t("privacy.subTitle1.1")}</p>
      </section>
      <section>
        <h2>{t("privacy.title2")}</h2> <p>{t("privacy.subTitle2.1")}</p>
        <p>{t("privacy.subTitle2.2")}</p>
      </section>
      <section>
        <h2>{t("privacy.title3")}</h2> <p>{t("privacy.subTitle3.1")}</p>
        <p>{t("privacy.subTitle3.2")}</p> <p>{t("privacy.subTitle3.3")}</p>
        <p>{t("privacy.subTitle3.4")}</p>
      </section>
      <section>
        <h2>{t("privacy.title4")}</h2> <p>{t("privacy.subTitle4.1")}</p>
        <p>{t("privacy.subTitle4.2")}</p>
      </section>
      <section>
        <h2>{t("privacy.title5")}</h2> <p>{t("privacy.subTitle5.1")}</p>
      </section>
      <section>
        <h2>{t("privacy.title6")}</h2> <p>{t("privacy.subTitle6.1")}</p>
      </section>
      <section>
        <h2>{t("privacy.title7")}</h2> <p>{t("privacy.subTitle7.1")}</p>
      </section>
      <section>
        <h2>{t("privacy.title8")}</h2> <p>{t("privacy.subTitle8.1")}</p>
      </section>
    </div>
  );
};
export default Privacy;
